import React from "react";
import { useTheme } from "next-themes";
import { Sun, Moon } from "lucide-react";

export const ThemeToggle = () => {
    const { theme, setTheme } = useTheme();
    const [mounted, setMounted] = React.useState(false);

    React.useEffect(() => setMounted(true), []);

    const isDark = theme === "dark";
    const toggle = () => setTheme(isDark ? "light" : "dark");

    return (
        <button
            data-testid="theme-toggle-btn"
            onClick={toggle}
            aria-label="Toggle color theme"
            className="relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-border bg-background/40 backdrop-blur-md transition-all hover:bg-primary/10 hover:border-primary/50"
        >
            {mounted ? (
                isDark ? (
                    <Sun className="h-[18px] w-[18px] text-primary" />
                ) : (
                    <Moon className="h-[18px] w-[18px] text-foreground" />
                )
            ) : (
                <span className="h-[18px] w-[18px]" />
            )}
        </button>
    );
};

export default ThemeToggle;
